
import instance, { instanceFile } from '../../ApiConfig';
import { URLS } from '../../ApiConfig/Urls'

const fetchPaymentType = async () => {
    try {
        const response = await instance.get(URLS.GetAdmin+URLS.GetPaymentTypes);

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch Vehicle Insurance');
    } catch (error) {
        console.error(error)
        throw error;
    }
};

const fetchPaymentTypeByID = async (InsuranceID) => {
    try {
        const response = await instance.get(URLS.GetAdmin+URLS.GetPaymentTypes+ '/'+ InsuranceID);

        if (response.status === 200) {
            return response.data;
        }

        throw new Error('Failed to fetch Vehicle Insurance');
    } catch (error) {
        console.error(error)
        throw error;
    }
};



const createPaymentType = async (vehicleData) => {
    try {
        const response = await instance.post(URLS.GetAdmin+URLS.GetPaymentTypes, vehicleData);
        if (response.status === 201) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error(error)
    }
}

const updatePaymentType = async (paymentTypeID,updatePaymentTypeData) => {

    try {
        const response = await instance.put(URLS.GetAdmin+URLS.GetPaymentTypes +'/'+ paymentTypeID, updatePaymentTypeData); // Adjust the URL as needed
        if (response.status === 200) {
            console.log("Vehicle Insurance Updated successfully")
            return response.data
        } else {
            return null
        }
    } catch (error) {
        console.error('Error sending verification code:', error);
        return null
    }
};


const deletePaymentType = async (InsuranceID) => {
    try {
        const response = await instance.delete(URLS.GetAdmin+URLS.GetPaymentTypes+'/' + InsuranceID );
        if (response.status === 204) {
            return response;
        }
        return null;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export default {
    fetchPaymentType,
    fetchPaymentTypeByID,
    createPaymentType,
    updatePaymentType,
    deletePaymentType
}
